/** Tipos de PQRS (Peticiones, Quejas, Reclamos y Sugerencias). */
export const PQRS_TYPES = [
  { value: 'peticion', label: 'Petición', description: 'Solicitud de información o actuación sobre un tema concreto.' },
  { value: 'queja', label: 'Queja', description: 'Manifestación de inconformidad por la conducta o actuación de la entidad.' },
  { value: 'reclamo', label: 'Reclamo', description: 'Exigencia por el incumplimiento de un deber o por un perjuicio.' },
  { value: 'sugerencia', label: 'Sugerencia', description: 'Propuesta para mejorar procesos o la atención a los asociados.' },
  { value: 'felicitacion', label: 'Felicitación', description: 'Reconocimiento por un buen servicio o gestión.' },
  { value: 'otro', label: 'Otro', description: 'Consulta general u otro tipo de comunicación.' },
];

export function getPqrsTypeLabel(value) {
  return PQRS_TYPES.find((t) => t.value === value)?.label ?? value;
}
